import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { URLConfig } from "../../../configs/url-config";


@Injectable({
  providedIn: "root"
})
export class ApiService {
private http=inject(HttpClient)
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "multipart/form-data;"
    })
  };
  httpOptionsPost = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      'accept': 'application/json',
    })
  };
  
  downloadFile(url: string): Observable<Blob> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/octet-stream',
      'responseType': 'blob'
    });

    return this.http.get(`${URLConfig.files}?link=${url}`, {
      headers: headers,
      responseType: 'blob'
    });
  }

  post(url: any, dataModel: any) {
    return this.http.post(url, dataModel, this.httpOptionsPost);
  }

 
 

  getRequest<T>(url: string): Observable<T> {
    return this.http.get<T>(url);
  }

  getRequestWithParams<T>(url: string, params: any): Observable<T> {
    return this.http.get<T>(url, { params: params });
  }
  getItemDetail<T>(url: string, params: any): Observable<T> {
    return this.http.get<T>(url, { params: params });
  }

  postRequest<T>(url: string, dataModel: any): Observable<T> {
    return this.http.post<T>(url, dataModel);
  }

  postRequestWithParams<T>(url: string, dataModel: any, params: any): Observable<T> {
    return this.http.post<T>(url, dataModel, { params });
  }

  postFormDataRequest(url: any, dataModel: any) {
    return this.http.post(url, dataModel, this.httpOptions);
  }

  patchRequest(url: any, dataModel: any) {
    return this.http.patch(url, dataModel);
  }

  putRequest(url: any, dataModel: any) {
    return this.http.put(url, dataModel);
  }

  putFormDataRequest(url: any, dataModel: any) {
    return this.http.put(url, dataModel, this.httpOptions);
  }

  async verifyToken(url: any, dataModel: any) {
    return await this.http.post(url, dataModel).toPromise();
  }

  deleteRequest(url: any,params: any) {
    return this.http.delete(url,{ params: params });
  }

  deleteRequestbody(url: any,params: any) {
    return this.http.delete(url,{body: params });
  }
}
